import { LayoutDashboard } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const dashboardNavigation: NavItem[] = [
  { to: '/', labelKey: 'nav.dashboard', group: 'nav.groups.main', icon: LayoutDashboard, exact: true },
]
